export default __webpack_public_path__ + "static/media/bb-00012.4878758b.png";